import { createService } from '@api';

export default {
  list: createService('company/settings', 'post'),
  update: createService('company/data/update', 'post'),
};
